const getTranslationValue = (translations, key) => {
    if (!translations || !key) {
        return undefined;
    }

    if (Object.prototype.hasOwnProperty.call(translations, key)) {
        return translations[key];
    }

    if (typeof key !== 'string') {
        return undefined;
    }

    const matchingKey = Object.keys(translations).find((translationKey) =>
        translationKey?.toLowerCase() === key.toLowerCase()
    );

    return matchingKey ? translations[matchingKey] : undefined;
};

export const translate = (key) => {
    if (!key) {
        return key;
    }

    const translations = window.__litium?.translation || {};
    const translatedValue = getTranslationValue(translations, key);
    if (translatedValue) {
        return translatedValue;
    }

    if (typeof key === 'string' && key.startsWith('js.')) {
        const normalizedKey = key.substring(3);
        const normalizedTranslatedValue = getTranslationValue(translations, normalizedKey);
        if (normalizedTranslatedValue) {
            return normalizedTranslatedValue;
        }
    }

    return key;
};

export const translateOrFallback = (key, fallbackKey) => {
    const translatedValue = translate(key);
    if (translatedValue && translatedValue !== key) {
        return translatedValue;
    }

    const fallbackValue = translate(fallbackKey);
    if (fallbackValue && fallbackValue !== fallbackKey) {
        return fallbackValue;
    }

    return translatedValue || fallbackValue || key;
};
